function whitelist(data, steps) {
  const fieldsToTrack = steps.reduce((fields, step) => {
    return fields.concat(step.fields.filter(f => f.trackInput).map(f => f.name))
  }, [])

  return Object.entries(data).reduce((obj, [key, value]) => {
    return { [key]: fieldsToTrack.includes(key) ? value : 'untracked', ...obj }
  }, {})
}

export default whitelist
